import { baseurl } from "../../api";
import authenticatedAxios from "../../authenticatedAxios";

// ─── CREATE ───────────────────────────────────────────────────────────────────

export const createReleaseNote = async (payload) => {
  try {
    const response = await authenticatedAxios.post(
      `${baseurl}release-notes/create/`,
      payload
    );
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Failed to create release note.";
    throw new Error(message);
  }
};

// ─── LIST ─────────────────────────────────────────────────────────────────────

export const fetchReleaseNotes = async (filters = {}) => {
  try {
    const params = new URLSearchParams();

    if (filters.search) params.set("search", filters.search);
    if (filters.filter) params.set("filter", filters.filter);
    if (filters.sort)   params.set("sort",   filters.sort);

    const response = await authenticatedAxios.get(
      `${baseurl}release-notes/list/?${params.toString()}`
    );

    const result = response.data;
    const data = result?.data ?? result;
    if (Array.isArray(data)) return data;
    return [];

  } catch (error) {
    const message = error.response?.data?.message || error.message || "Failed to fetch release notes.";
    throw new Error(message);
  }
};

// ─── UPDATE ───────────────────────────────────────────────────────────────────

export const updateReleaseNote = async (id, payload) => {
  try {
    const response = await authenticatedAxios.patch(
      `${baseurl}release-notes/update/${id}/`,
      payload
    );
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Failed to update release note.";
    throw new Error(message);
  }
};

// ─── PUBLISH ──────────────────────────────────────────────────────────────────

export const publishReleaseNote = async (id) => {
  try {
    const response = await authenticatedAxios.patch(
      `${baseurl}release-notes/update/${id}/`,
      { status: "published" }
    );
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Failed to publish release note.";
    throw new Error(message);
  }
};

export const deleteReleaseNote = async (id) => {
  try {
    await authenticatedAxios.delete(`${baseurl}release-notes/delete/${id}/`);
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Failed to delete release note.";
    throw new Error(message);
  }
};